<template>
  <div class="page">
    <header-title :title="title">
      <template #right>
        <andon-badge
          style="margin-right: 10px"
          :region-code="regionCode"
        ></andon-badge>
        <span @click="refresh">
          <RedoOutlined />
        </span>
      </template>
    </header-title>
    <div class="page-body">
      <a-table
        :columns="columns"
        :row-key="(record) => record.id"
        :data-source="dataSource"
        :loading="loading"
        :pagination="{ defaultPageSize: 20 }"
        size="small"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'action'">
            <a-button
              :type="record.status === 'open' ? 'primary' : ''"
              size="small"
              v-if="record.status !== 'wip'"
              :disabled="record.isCA"
              @click="start(record)"
            >
              Start
            </a-button>
            <a-divider v-if="record.status !== 'wip'" type="vertical" />
            <a-button
              :class="{ 'button-energized': record.status === 'wip' }"
              size="small"
              v-if="record.status !== 'open'"
              :disabled="record.isCA"
              @click="reverseStart(record)"
            >
              Reverse
            </a-button>
            <a-divider v-if="record.status !== 'open'" type="vertical" />
            <a-button
              :class="{ 'button-balanced': record.status === 'wip' }"
              size="small"
              :disabled="record.isCA"
              @click="finish(record)"
            >
              Finish
            </a-button>
          </template>
        </template>
      </a-table>
    </div>
    <a-modal
      v-model:visible="endDiffModal"
      title="Enter Tag ID 请输入标签编号"
      @cancel="endDiffModal = false"
      @ok="endDiffOk"
      wrap-class-name="has-table-full-modal"
    >
      <a-input
        v-model:value="endTagId"
        placeholder="Enter Tag ID 请输入标签编号"
      ></a-input>
    </a-modal>
  </div>
</template>

<script>
  import { parseTime } from '@/utils'
  import HeaderTitle from '@/layout/header-title'
  import { getMainList, reverseStart } from '@/api/manual'

  import {
    startReq,
    checkManualTag,
    endReq,
    preEndCheckForDisplay,
    getIsManualBinding,
    preEndCheck,
    getMatAllExist,
    isSimpleUI,
  } from '@/api/workStation'

  import { RedoOutlined } from '@ant-design/icons-vue'
  import { Modal, message } from 'ant-design-vue'
  import AndonBadge from '@/components/andon-badge'
  export default {
    components: { HeaderTitle, AndonBadge, RedoOutlined },

    data() {
      return {
        title: 'Manual WorkStation ' + this.$route.params.regionCode,
        isForce: false,
        tagId: '',
        loading: false,
        regionCode: this.$route.params.regionCode,
        dataSource: [],
        endDiffModal: false,
        curRow: {},

        loop: null,
        columns: [
          {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            customRender({ index }) {
              return index + 1
            },
            width: 60,
          },
          {
            title: 'Job ID',
            dataIndex: 'jobId',
            minWidth: 100,
          },
          {
            title: 'Sub Job ID',
            dataIndex: 'job_id',
            minWidth: 100,
            customRender({ record }) {
              return record.subJobId1 || record.subJobId2
            },
          },
          {
            title: 'Region',
            dataIndex: 'regionCode',
            minWidth: 100,
          },
          {
            title: 'Production Line',
            dataIndex: 'productionLine',
            minWidth: 100,
          },
          {
            title: 'Est.End',
            dataIndex: 'estEnd',
            minWidth: 100,
            customRender({ text }) {
              return parseTime(text, '{m}/{d} {h}:{i}')
            },
          },
          {
            title: 'Req.End',
            dataIndex: 'reqEnd',
            minWidth: 100,
            customRender({ text }) {
              return parseTime(text, '{m}/{d} {h}:{i}')
            },
          },
          {
            title: 'Status',
            dataIndex: 'status',
            minWidth: 100,
          },
          {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            minWidth: 180,
          },
        ],
      }
    },
    async created() {
      await this._isSimpleUI()
      this._getPageData()
    },

    methods: {
      _isSimpleUI() {
        return new Promise((resolve) => {
          isSimpleUI({ regionCode: this.regionCode })
            .then((res) => {
              if (!res.body) {
                this.$router.push({
                  path: `/workStation/${this.regionCode}`,
                  replace: true,
                })
              }
            })
            .finally(() => {
              resolve()
            })
        })
      },
      refresh() {
        this._getPageData()
      },
      async _getPageData() {
        this.loading = true
        try {
          const d = await getMainList(this.regionCode)
          if (d.errCode === '0000') {
            if (d.body) {
              const dataSource = d.body.map((item) => {
                let isCA =
                  (item.interfaceType &&
                    item.interfaceType
                      .toLocaleLowerCase()
                      .split(',')
                      .includes('ca')) ||
                  false
                item.isCA = isCA
                return item
              })
              this.dataSource = dataSource
            } else {
              this.dataSource = []
            }
          }

          this.loading = false
        } catch (e) {
          this.loading = false
        }

        return Promise.resolve()
      },
      async start(row) {
        const loading = message.loading('Loading……', 0)
        try {
          if (row.status !== 'open') {
            message.warning('非Open状态不允许操作')
            loading()
            return
          }
          const req = {
            regionCode: this.regionCode,
            jobId: row.jobId,
            uuid: row.id,
          }
          const d = await startReq(req)
          if (d.errCode === '0000') {
            this._getPageData()
            message.success('Success！')
            loading()
          } else {
            Modal.error({ title: 'Error', content: d.errMsg })
            loading()
          }
        } catch (e) {
          loading()
        }
      },
      reverseStart(row) {
        if (row.status !== 'wip') {
          message.warning('非WIP状态不允许操作')
          return
        }
        const _this = this
        Modal.confirm({
          title: `Are you sure to reverse from wip to open?`,
          content: ' 是否确认退回到未开始状态？',
          width: 550,
          async onOk() {
            const loading = message.loading('Loading……', 0)
            try {
              const d = await reverseStart({
                regionCode: _this.regionCode,
                jobId: row.jobId,
                uuid: row.id,
              })
              if (d.errCode === '0000') {
                _this._getPageData()
                message.success('Success！')
                loading()
              } else {
                Modal.error({ title: 'Error', content: d.errMsg })
                loading()
              }
            } catch (e) {
              loading()
            }
          },
        })
      },
      endDiffOk() {
        if (this.endTagId) {
          // Check if tag is valid
          this.tagId = this.endTagId
          checkManualTag(this.endTagId).then((res) => {
            if (res.errCode === '0000') {
              this._execEnd(this.curRow)
              this.endDiffModal = false
            } else {
              Modal.error({ title: 'Error', content: res.errMsg })
            }
          })
        } else {
          message.error('Please enter tag ID 必须输入标签ID!')
        }
      },
      async _execEnd(row) {
        let __end = async function (data, that, row) {
          const regionCode = that.regionCode
          const jobId = row.jobId
          const query = {
            regionCode,
            jobId,
            force: that.isForce,
            tagId: that.tagId,
            uuid: row.id,
          }
          const d = await endReq(query)
          if (d.errCode === '0000') {
            that._getPageData()
            if (data.body) {
              let _tagidDisplay = data.body[3].tagidDisplay,
                _tagId = data.body[2].tagId
              if (_tagidDisplay && _tagId) {
                Modal.warning({
                  title: 'Tips',
                  content:
                    '当前工单JOb Id: ' + row.jobId + '成品在Tag Id: ' + _tagId,
                  afterClose: () => {
                    message.success('Success！')
                  },
                })
              }
            } else {
              message.success('Success！')
            }
          } else {
            Modal.error({ title: 'Error', content: d.errMsg })
          }
        }
        const resp = await preEndCheckForDisplay({
          regionCode: this.regionCode,
          jobId: row.jobId,
          uuid: row.id,
        })
        __end(resp, this, row)
      },
      async _endOfDiffMode(row) {
        const d = await getIsManualBinding({
          regionCode: this.regionCode,
          uuid: row.id,
        })
        if (d.errCode === '0000') {
          if (d.body) {
            this.curRow = row
            this.endDiffModal = true
          } else {
            this._execEnd(row)
          }
        } else {
          Modal.error({ title: 'Error', content: d.errMsg })
        }
      },
      async finish(row) {
        const regionCode = this.regionCode
        if (row.status !== 'wip') {
          message.warning('非WIP状态不允许操作')
          return
        }
        const _this = this
        const d = await preEndCheck({
          regionCode,
          jobId: row.jobId,
          tagId: _this.tagId,
          uuid: row.id,
        })
        if (d.errCode === '0000') {
          Modal.confirm({
            title: `Are you sure to finish this operation? `,
            content: '是否确认生产任务已完成？',
            width: 550,
            async onOk() {
              const res = await getMatAllExist({
                regionCode,
                jobId: row.jobId,
                uuid: row.id,
              })
              if (res.errCode === '0000') {
                if (res.body) {
                  Modal.confirm({
                    title: res.body,
                    width: 550,
                    onOk() {
                      _this.isForce = true
                      _this._endOfDiffMode(row)
                    },
                  })
                } else {
                  _this._endOfDiffMode(row)
                }
              } else {
                Modal.error({ title: 'Error', content: res.errMsg })
              }
            },
            onCancel() {},
          })
        } else {
          Modal.error({ title: 'Error', content: d.errMsg })
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';

  .page-body {
    height: calc(100vh - 34px - 46px);
    overflow: auto;
  }
  .button-energized {
    background: #ffc13f;
    border-color: #e5a927;
  }
  .button-balanced {
    background: #2caa48;
    border-color: #1b8c34;
  }
</style>
<style lang="less">
  .has-table-full-modal {
    .ant-modal-body {
      padding: 0;
    }
  }
</style>
